export const SUPPORTED_LANGS = [
	'en',
	'ar',
	'fr',
	'id',
	'ja',
	'ko',
	'pt',
	'es',
	'th',
] as const;

export const DEFAULT_LANG = 'en';

export const FEED_TIMELINE_PAGE_SIZE = 10;

export const BRAZE_CITYZENS_KEY_VALUE_PAIRS = [
	{ key: 'Cityzens', value: 'Top' },
] as const;
